import Particles, { initParticlesEngine } from "@tsparticles/react"
import { loadSlim } from "@tsparticles/slim"
import { useEffect, useState } from "react";
import particleconfig from "../components/config/particles-config";
import SiteHeader from '../components/SiteHeader';
import "../components/css/Privacy.css"

export default function PrivacyPolicy() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    })
  }, []);

  const particlesLoaded = (container) => {
    console.log("Particles loaded:", container);
  };

  return (
    <div className="App">
      <SiteHeader />
      <div className="wrapper">
        <div className="Privacy">
          <h1>Privacy Policy</h1>
          <p>All my software and games provide countless hours of enjoyment and useability.</p>

          <p>Privacy is important, and people shouldn't have to worry about where their sensitive data is going.</p>

          <strong>Software and games developed by me will never collect your data without your consent, and will be strongly outlined when 
            data is accessed, and where that data will be going. My software saves their required functional data that is generated by the program and does not store any additional data that 
            is not created or maintained by the software.</strong>

          <p>If you encounter a vulnerability, a breach, or any other integral issues please reach out to me directly.</p>
        </div>
      </div>
      {init && (<Particles id="tsparticles" options={particleconfig} particlesLoaded={particlesLoaded}></Particles>)}
    </div>
  );
  }